export default "__VITE_ASSET__DJ8DTmlB__"